export default __webpack_public_path__ + "static/media/sa.013f7c1d.svg";